import React from 'react';
import i18n from '../../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import FormField from "../../Form/FormField";
import FormDate from "../../Form/FormDate";
import Grid from "@material-ui/core/Grid/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import {Hidden, withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../../Form/utils";
import FormCheck from "../../Form/FormCheck";
import swal from "sweetalert";
import FormAutocomplete from "../../Form/FormAutocomplete";
import {array, object, string} from "yup";
import DeleteButton from "../../Form/DeleteButton";
import FormSelect from "../../Form/FormSelect";
import Divider from '@material-ui/core/Divider';
import MediaDropButton from '../../Media/DropButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from "@material-ui/core/Typography";
import SignatureCanvas from 'react-signature-canvas';
import FormRadio from "../../Form/FormRadio";

class Presses extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompany: false,
            signatureData1: '',
            signatureData2: '',
            updatingFields: false,
        };
    }

    sigCanvas1 = {}
    sigCanvas2 = {}

    handleSign1 = () => {
        this.setState({signatureData1: this.sigCanvas1.toDataURL()});
    }
    handleSign2 = () => {
        this.setState({signatureData2: this.sigCanvas2.toDataURL()});
    }

    render() {
        const {
            classes,
            values,
            protocol,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            formUrl,
            customer,
            structure,
            uploadConfig,
        } = this.props;

        values.signature1 = this.state.signatureData1
        values.signature2 = this.state.signatureData2
        if(protocol && protocol.is_correction) {
            values.is_correction = true;
            values.from_protocol_id = protocol.id;
        }

        return (
            <React.Fragment>
                <Grid item>
                    <Grid container spacing={16} alignItems="center">
                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="cost_center"
                                label='Kostenstelle:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.cost_center}
                            />
                        </Grid>
                        <Grid item xs={8}>&nbsp;</Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="producer"
                                label='Hersteller:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.producer}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="serial_number"
                                label='Seriennummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.serial_number}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="inventory_number"
                                label='Inventarnummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.inventory_number}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="type"
                                label='Typ:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.type}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="construction_year"
                                label='Baujahr:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.construction_year}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="number"
                                name="nominal_pressure"
                                label='Nenndruck:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.nominal_pressure}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="number"
                                name="rated_current"
                                label='Nennstrom:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.rated_current}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="number"
                                name="rated_voltage"
                                label='Nennspannung:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.rated_voltage}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="number"
                                name="rated_power"
                                label='Nennleistung:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.rated_power}
                            />
                        </Grid>

                        <Grid item xs={2}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                <b><u>Bauart:</u></b>
                            </Typography>
                        </Grid>
                        <Grid item xs={10}>
                            <Grid container>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="type_1"
                                        label='mechanische Presse'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.type_1}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="type_2"
                                        label='hydraulische Presse'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.type_2}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="type_3"
                                        label='Spindelpresse'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.type_3}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="type_4"
                                        label='sonstige'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.type_4}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={2}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                <b><u>Prüfgrundlage:</u></b>
                            </Typography>
                        </Grid>
                        <Grid item xs={10}>
                            <Grid container>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="test_basis_1"
                                        label='VBG 7n5.1'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.test_basis_1}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="test_basis_2"
                                        label='FVBG 7n5.2'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.test_basis_2}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="test_basis_3"
                                        label='VBG 7n5.3'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.test_basis_3}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="test_basis_4"
                                        label='BetrSichV'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.test_basis_4}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography component={"div"}
                                        variant={"body1"}>

                            </Typography>
                        </Grid>
                        <Grid item xs={10}>
                            <Grid container>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="test_basis_5"
                                        label='EN 692'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.test_basis_5}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="test_basis_6"
                                        label='EN 693'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.test_basis_6}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="test_basis_7"
                                        label='EN 289'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.test_basis_7}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={3} xs={12}>

                                </Grid>
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Divider/>
                </Grid>

                <Table width="90% !important">
                    <TableHead>
                        <TableRow>
                            <TableCell width="20%">
                                &nbsp;
                            </TableCell>
                            <TableCell width="26%">
                                &nbsp;
                            </TableCell>
                            <TableCell width="25%">
                                &nbsp;
                            </TableCell>
                            <TableCell width="29%">
                                &nbsp;
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <b>
                                    <u>
                                        1. Elektrische Anlage:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                regelmäßige Prüfung
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_1_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_1_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_1_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_1_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_1_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_1_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <b>
                                    <u>
                                        2. Hauptschalter:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Hauptschalter abschließbar
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_2_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_2_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_2_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_2_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_2_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_2_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <b>
                                    <u>
                                        3. Wahlschalter:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Wahlschalter abschließbar
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_3_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_3_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_3_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_3_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_3_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_3_defect || ''}
                                />
                            </TableCell>
                        </TableRow>



                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Angaben leserlich
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_3_b_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_3_b_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_3_b_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_3_b_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_3_b_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_3_b_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Schlüssel nur in verriegelter Stellung abschließbar
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_3_c_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_3_c_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_3_c_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_3_c_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_3_c_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_3_c_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Keine Hubauslösung durch Umstellen der Betriebsart
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_3_d_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_3_d_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_3_d_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_3_d_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_3_d_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_3_d_defect || ''}
                                />
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell colSpan={4}>
                                <b>
                                    <u>
                                        4. Notaustaster:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Taster rastend
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_4_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_4_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_4_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_4_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_4_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_4_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                gefahrbringende Bewegungen werden bei Betätigung stillgesetzt
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_4_b_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_4_b_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_4_b_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_4_b_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_4_b_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_4_b_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                kein Selbstanlauf durch Rückstellen
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_4_c_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_4_c_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_4_c_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_4_c_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_4_c_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_4_c_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Funktion erfolgt vor der Verrastung (Überlistungssicher)
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_4_d_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_4_d_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_4_d_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_4_d_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_4_d_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_4_d_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <b>
                                    <u>
                                        5. Schaltschrank:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Schaltschrank abgedichtet
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_5_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_5_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_5_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_5_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_5_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_5_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Vorschriftsmäßiger Berührungsschutz der Betriebsmittel
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_5_b_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_5_b_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_5_b_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_5_b_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_5_b_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_5_b_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <b>
                                    <u>
                                        6. Schaltgestänge:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                fester Sitz von Nocken und Endschaltern
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_6_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_6_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_6_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_6_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_6_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_6_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <b>
                                    <u>
                                        7. Öl:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Ölfilter nicht verschmutzt
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_7_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_7_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_7_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_7_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_7_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_7_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Ölstand ausreichend
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_7_b_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_7_b_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_7_b_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_7_b_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_7_b_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_7_b_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <b>
                                    <u>
                                        8. Rohrleitungen:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Vorschriftsmäßige Verschraubungen
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_8_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_8_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_8_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_8_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_8_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_8_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                fester Sitz an den Befestigungspunkten
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_8_b_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_8_b_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_8_b_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_8_b_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_8_b_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_8_b_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Dichtheit
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_8_c_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_8_c_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_8_c_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_8_c_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_8_c_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_8_c_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <b>
                                    <u>
                                        9. Hydraulikschläuche:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Kennzeichnung
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_9_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_9_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_9_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_9_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_9_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_9_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Eignung
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_9_b_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_9_b_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_9_b_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_9_b_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_9_b_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_9_b_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                {'Verwendungsdauer < 6 Jahre'}
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_9_c_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_9_c_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_9_c_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_9_c_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_9_c_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_9_c_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Beschädigungen (Schmierstellen, Risse, Schnitte)
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_9_d_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_9_d_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_9_d_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_9_d_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_9_d_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_9_d_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Versprödung
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_9_e_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_9_e_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_9_e_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_9_e_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_9_e_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_9_e_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Verformung (Blasen, Quetschstellen, Knickstellen)
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_9_f_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_9_f_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_9_f_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_9_f_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_9_f_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_9_f_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Dichtheit
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_9_g_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_9_g_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_9_g_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_9_g_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_9_g_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_9_g_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <b>
                                    <u>
                                        10. Druckbegrenzungsventile:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                korrekte Öffnungsdrücke
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_10_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_10_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_10_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_10_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_10_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_10_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <b>
                                    <u>
                                        11. Rückschlagventile (Rückzug):
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                fehlerfreie Funktion (Druckausfalltest)
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_11_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_11_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_11_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_11_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_11_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_11_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <b>
                                    <u>
                                        12. Stellungsüberwachungen:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                B Störung Spannung perm. 1
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_12_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_12_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_12_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_12_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_12_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_12_defect || ''}
                                />
                            </TableCell>
                        </TableRow>


                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                B Störung Spannung perm. 0
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_12_b_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_12_b_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_12_b_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_12_b_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_12_b_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_12_b_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                B Störung Spannung perm. 1
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_12_c_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_12_c_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_12_c_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_12_c_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_12_c_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_12_c_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                B Störung Spannung perm. 0
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_12_d_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_12_d_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_12_d_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_12_d_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_12_d_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_12_d_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                B Störung Spannung perm. 1
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_12_e_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_12_e_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_12_e_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_12_e_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_12_e_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_12_e_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                B Störung Spannung perm. 0
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_12_f_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_12_f_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_12_f_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_12_f_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_12_f_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_12_f_defect || ''}
                                />
                            </TableCell>
                        </TableRow>


                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                B Störung Spannung perm. 1
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_12_g_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_12_g_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_12_g_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_12_g_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_12_g_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_12_g_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                B Störung Spannung perm. 0
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_12_h_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_12_h_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_12_h_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_12_h_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_12_h_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_12_h_defect || ''}
                                />
                            </TableCell>
                        </TableRow>



                        <TableRow>
                            <TableCell colSpan={4}>
                                <b>
                                    <u>
                                        13. Pressengestell:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                keine Rissbildung
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_13_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_13_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_13_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_13_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_13_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_13_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <b>
                                    <u>
                                        14. Zylinderbefestigung:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                fester Sitz der Befestigungsschrauben
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_14_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_14_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_14_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_14_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_14_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_14_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <b>
                                    <u>
                                        15. Stößelaufhängung:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                fester Sitz der Befestigungsschrauben
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_15_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_15_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_15_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_15_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_15_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_15_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <b>
                                    <u>
                                        16. Leitern, Treppen, Arbeitsbühnen:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                vorschriftsmäßige Leiter, Treppen, Geländer
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_16_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_16_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_16_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_16_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_16_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_16_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Gitterroste ausreichend befestigt
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_16_b_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_16_b_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_16_b_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_16_b_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_16_b_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_16_b_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <b>
                                    <u>
                                        17. Stößelverriegelung:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Endschalter und Leitung unbeschädigt
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_17_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_17_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_17_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_17_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_17_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_17_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Anzeige des verriegelten Zustandes
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_17_b_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_17_b_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_17_b_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_17_b_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_17_b_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_17_b_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Störung bei abgeklemmten Schalter
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_17_c_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_17_c_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_17_c_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_17_c_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_17_c_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_17_c_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <b>
                                    <u>
                                        18. Peripherieantriebe:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Schutzabdeckung vorhanden
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_18_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_18_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_18_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_18_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_18_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_18_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <b>
                                    <u>
                                        19. Umzäunung, Türen hinten:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Gefahrenbereich vom Bedienpult aus einsehbar
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_19_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_19_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_19_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_19_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_19_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_19_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Endschalter nicht manipuliert
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_19_b_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_19_b_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_19_b_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_19_b_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_19_b_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_19_b_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Quittiertaster vorhanden (begehbar)
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_19_c_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_19_c_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_19_c_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_19_c_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_19_c_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_19_c_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Quittiertaster nicht aus dem Gefahrenbereich erreichbar
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_19_d_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_19_d_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_19_d_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_19_d_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_19_d_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_19_d_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Sichtverbindung zum Gefahrenbereich
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_19_e_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_19_e_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_19_e_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_19_e_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_19_e_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_19_e_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Störung bei permanntem Betätigen des Quittiertasters
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_19_f_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_19_f_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_19_f_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_19_f_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_19_f_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_19_f_defect || ''}
                                />
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell colSpan={4}>
                                <b>
                                    <u>
                                        20. feststehende Verkleidungen und Verdeckungen:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Nur mit Werkzeug entfernbar
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_20_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_20_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_20_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_20_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_20_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_20_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Nicht unter-, über-, um-, durchgreifbar
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_20_b_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_20_b_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_20_b_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_20_b_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_20_b_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_20_b_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <b>
                                    <u>
                                        21. bewegliche Verkleidungen und Verdeckungen:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Nicht unter-, über-, um-, durchgreifbar
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_21_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_21_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_21_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_21_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_21_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_21_defect || ''}
                                />
                            </TableCell>
                        </TableRow>


                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Endschalter nicht manipuliert
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_21_b_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_21_b_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_21_b_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_21_b_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_21_b_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_21_b_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Hubauslösung nur wenn geschlossen
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_21_c_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_21_c_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_21_c_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_21_c_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_21_c_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_21_c_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Bewegung bei Öffnen rechtzeitig stillgesetzt
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_21_d_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_21_d_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_21_d_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_21_d_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_21_d_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_21_d_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Endschalter funktionsfähig und nicht manipuliert
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_21_e_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_21_e_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_21_e_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_21_e_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_21_e_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_21_e_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Schutzmaßnahmen (Kontaktleiste) funktionsfähig
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_21_f_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_21_f_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_21_f_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_21_f_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_21_f_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_21_f_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <b>
                                    <u>
                                        22. Nachlaufmessung:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                <Grid container alignItems="center">
                                    <Grid item xs={10}>
                                        Nachlaufzeit ermittelt (10 Messungen)
                                    </Grid>
                                    <Grid item xs={2}>
                                        <FormField
                                            type="text"
                                            name="content_22_input"
                                            label='ms'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.content_22_input}
                                        />
                                    </Grid>
                                </Grid>
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_22_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_22_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_22_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_22_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_22_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_22_defect || ''}
                                />
                            </TableCell>
                        </TableRow>


                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Art der Schutzmaßnahme
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_22_b_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_22_b_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_22_b_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_22_b_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_22_b_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_22_b_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                <Grid container alignItems="center">
                                    <Grid item xs={10}>
                                        {'Bei BWS: Abstand zur Gefahrenstelle </ > 5OOmm'}
                                    </Grid>
                                    <Grid item xs={2}>
                                        <FormField
                                            type="text"
                                            name="content_22_c_input"
                                            label='mm'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.content_22_c_input}
                                        />
                                    </Grid>
                                </Grid>
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_22_c_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_22_c_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_22_c_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_22_c_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_22_c_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_22_c_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                <Grid container alignItems="center">
                                    <Grid item xs={10}>
                                        resultierender Sicherheitsabstand
                                    </Grid>
                                    <Grid item xs={2}>
                                        <FormField
                                            type="text"
                                            name="content_22_d_input"
                                            label='mm'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.content_22_d_input}
                                        />
                                    </Grid>
                                </Grid>
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_22_d_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_22_d_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_22_d_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_22_d_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_22_d_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_22_d_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                <Grid container alignItems="center">
                                    <Grid item xs={10}>
                                        Vorhandener Sicherheitsabstand
                                    </Grid>
                                    <Grid item xs={2}>
                                        <FormField
                                            type="text"
                                            name="content_22_e_input"
                                            label='mm'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.content_22_e_input}
                                        />
                                    </Grid>
                                </Grid>
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_22_e_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_22_e_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_22_e_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_22_e_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_22_e_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_22_e_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <b>
                                    <u>
                                        23. Stellungsüberwachungen:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Nachlaufzeit / Sicherheitsabstand angegeben
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_23_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_23_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_defect || ''}
                                />
                            </TableCell>
                        </TableRow>


                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Sicherheitsabstand angegeben
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_b_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_b_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_23_b_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_23_b_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_b_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_b_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Sicherung gegen verschieben vorhanden
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_c_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_c_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_23_c_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_23_c_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_c_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_c_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                {'Hintertretschutz (falls erforderlich) < 75 mm vorhanden'}
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_d_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_d_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_23_d_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_23_d_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_d_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_d_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                zu öffnende, entfernbare Sicherungen überwacht
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_e_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_e_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_23_e_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_23_e_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_e_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_e_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Anzeige des Schaltzustandes überwacht
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_f_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_f_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_23_f_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_23_f_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_f_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_f_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                PE, FE angeschlossen
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_g_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_g_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_23_g_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_23_g_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_g_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_g_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Befehlsgerät für Reset vorhanden
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_h_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_h_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_23_h_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_23_h_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_h_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_h_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Befehlsgerät nicht aus Gefahrenbereich zu betätigen
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_i_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_i_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_23_i_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_23_i_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_i_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_i_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Besteht Sichtverbindung zum Gefahrenbereich
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_j_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_j_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_23_j_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_23_j_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_j_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_j_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                BWS-Typ vorschriftsmäßig
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_k_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_k_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_23_k_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_23_k_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_k_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_k_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Hubunterbrechung beim Einbringen des Prüfstabes
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_l_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_l_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_23_l_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_23_l_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_l_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_l_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Hubunterbrechung beim Ausschalten der BWS
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_m_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_m_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_23_m_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_23_m_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_m_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_m_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Leuchtmelder erlöschen beim Ausschalten
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_n_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_n_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_23_n_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_23_n_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_n_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_n_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Wiederanlaufsperre beim Wechsel der Betriebsart
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_o_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_o_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_23_o_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_23_o_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_o_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_o_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Wiederanlaufsperre bei Hubunterbrechung
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_p_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_p_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_23_p_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_23_p_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_p_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_p_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Wiederanlaufsperre bei Betriebsart: Schutz und Eingriff im OT
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_q_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_q_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_23_q_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_23_q_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_q_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_q_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Muting nachdem die Gefährdungen beseitigt sind
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_r_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_r_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_23_r_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_23_r_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_r_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_r_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Störung bei statischem Mutingsignal
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_s_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_s_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_23_s_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_23_s_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_s_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_s_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                {'Taktbetrieb: Dimensionen zulässig? (Tischhöhe >750 mm; Hub> 600'}
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_t_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_t_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_23_t_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_23_t_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_t_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_t_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Befehlsgerät für ersten Start erforderlich
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_u_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_u_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_23_u_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_23_u_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_u_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_u_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                {'Taktunterbrechung bei P>30s'}
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_v_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_v_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_23_v_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_23_v_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_v_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_v_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Altmaschinen vor 1987 o. CE: autom. Nachlaufkontrolle nach Einschalte
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_w_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_w_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_23_w_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_23_w_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_23_w_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_23_w_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <b>
                                    <u>
                                        24. Zweihandschaltungen (ZHS):
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Nachlaufzeit, Sicherheitsabstand angegeben
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_24_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_24_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_24_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_24_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_24_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_24_defect || ''}
                                />
                            </TableCell>
                        </TableRow>


                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Sicherheitsabstand eingehalten
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_24_b_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_24_b_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_24_b_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_24_b_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_24_b_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_24_b_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Sichtverbindung zum Gefahrenbereich
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_24_c_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_24_c_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_24_c_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_24_c_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_24_c_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_24_c_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                {'ZHS nicht leicht umgehbar(Abstand Taster > 260 mm;)'}
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_24_d_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_24_d_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_24_d_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_24_d_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_24_d_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_24_d_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Anschlussleitung und Stecker unbeschädigt
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_24_e_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_24_e_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_24_e_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_24_e_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_24_e_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_24_e_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Hubunterbrechung beim Loslassen eines Tasters
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_24_f_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_24_f_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_24_f_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_24_f_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_24_f_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_24_f_defect || ''}
                                />
                            </TableCell>
                        </TableRow>


                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Altmaschinen vor 1987 o. CE: autom. Nachlaufkontrolle nach Einschalte
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_24_g_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_24_g_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_24_g_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_24_g_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_24_g_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_24_g_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                {'bei mögl. ZHS-Vorwahl: kein Selbstanlauf bei Stecken & Entfernen der Z'}
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_24_h_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_24_h_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_24_h_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_24_h_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_24_h_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_24_h_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <b>
                                    <u>
                                        25. Fußtaster:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Schutz gegen unbeabsichtigtes Betätigen
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_25_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_25_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_25_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_25_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_25_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_25_defect || ''}
                                />
                            </TableCell>
                        </TableRow>


                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Anschlussleitung unbeschädigt
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_25_b_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_25_b_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_25_b_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_25_b_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_25_b_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_25_b_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Taster leichtgängig
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_25_c_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_25_c_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_25_c_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_25_c_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_25_c_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_25_c_defect || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <b>
                                    <u>
                                        26. Schaltpläne, Steuerung:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                Steuerung theoretisch i.O.
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_26_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_26_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_26_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_26_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_26_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_26_defect || ''}
                                />
                            </TableCell>
                        </TableRow>


                        <TableRow>
                            <TableCell className={classes.smallerPadding}>
                                bei selbsüberwachender Schützsteuerung: Versagen sicherheitsrelevanter Schütze wird erkannt
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_26_b_test"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_26_b_test || ''}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormField
                                    type="text"
                                    name="content_26_b_remark"
                                    label="Bemerkungen"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.content_26_b_remark}
                                />
                            </TableCell>
                            <TableCell className={classes.smallerPadding}>
                                <FormRadio
                                    name="content_26_b_defect"
                                    options={[
                                        {
                                            value : 'minor',
                                            label : 'geringer Mangel'
                                        },
                                        {
                                            value : 'major',
                                            label : 'erheblicher Mangel'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.content_26_b_defect || ''}
                                />
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell colSpan={4}>
                                <FormField
                                    type="text"
                                    name="notations"
                                    label='Bemerkungen:'
                                    multiline
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.notations}
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>

                <Grid item xs={12}>
                    <FormRadio
                        name="inspection_tag"
                        options={[
                            {
                                value : 'yes',
                                label : 'Prüfplakette erteilt',
                            },
                            {
                                value : 'no',
                                label : 'Prüfplakette nicht erteilt',
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadio}
                        classNameRadio={classes.formButton}
                        onBlur={handleBlur}
                        value={values.inspection_tag}
                    />
                </Grid>
                <Hidden smDown>
                    <Grid item xs={1}>&nbsp;</Grid>
                </Hidden>
                <Grid item xs={2}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Datum:
                    </Typography>
                </Grid>
                <Grid item md={3} sm={4} justify="center">
                    <FormDate
                        type="date"
                        name="current_date"
                        // label={i18n.get('cooperations.day_last_appointment')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.current_date}
                    />
                </Grid>
                <Hidden smDown>
                    <Grid item xs={1}>&nbsp;</Grid>
                </Hidden>
                <Grid item xs={2}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Nächster Prüftermin:
                    </Typography>
                </Grid>
                <Grid item md={3} sm={4} justify="center">
                    <FormDate
                        type="date"
                        name="next_date"
                        // label={i18n.get('cooperations.day_last_appointment')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.next_date}
                    />
                </Grid>

                <Hidden smDown>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={1}>&nbsp;</Grid>
                            <Grid item xs={10} style={{ border: '1px solid black' }}>
                                <SignatureCanvas
                                    penColor='black'
                                    canvasProps={{width: 500, height: 200}}
                                    ref={(ref) => { this.sigCanvas1 = ref }}
                                    onEnd={this.handleSign1}
                                />
                            </Grid>
                            <Grid item xs={1}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item md={6} sm={12} xs={12}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={1}>&nbsp;</Grid>
                            <Grid item xs={10} style={{ border: '1px solid black' }}>
                                <SignatureCanvas
                                    penColor='black'
                                    canvasProps={{width: 500, height: 200}}
                                    ref={(ref) => { this.sigCanvas2 = ref }}
                                    onEnd={this.handleSign2}
                                />
                            </Grid>
                            <Grid item xs={1}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={3}>&nbsp;</Grid>
                            <Grid item xs={6} style={{ textAlign: "right" }}>
                                <Typography component={"div"}
                                            variant={"body1"}>
                                    Unterschrift Auftraggeber
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={3}>&nbsp;</Grid>
                            <Grid item xs={6} style={{ textAlign: "right" }}>
                                <Typography component={"div"}
                                            variant={"body1"}>
                                    Unterschrift Prüfer
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                </Hidden>

                <Hidden mdUp>
                    <Grid item xs={12} style={{ border: '1px solid black' }}>
                        <SignatureCanvas
                            penColor='black'
                            canvasProps={{width: 500, height: 200}}
                            ref={(ref) => { this.sigCanvas1 = ref }}
                            onEnd={this.handleSign1}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Typography component={"div"}
                                    variant={"body1"}>
                            Unterschrift Auftraggeber
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>&nbsp;</Grid>
                    <Grid item xs={12} style={{ border: '1px solid black' }}>
                        <SignatureCanvas
                            penColor='black'
                            canvasProps={{width: 500, height: 200}}
                            ref={(ref) => { this.sigCanvas2 = ref }}
                            onEnd={this.handleSign2}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Typography component={"div"}
                                    variant={"body1"}>
                            Unterschrift Prüfer
                        </Typography>
                    </Grid>
                </Hidden>
            </React.Fragment>
        )
    }
}

const styles = theme => ({
    deleteButton: {
        // background: theme.colors.error
    },
    textLeft: {
        textAlign: "left",
    },
    textCenter: {
        textAlign: "center",
    },
    textRight: {
        textAlign: "right",
    },
    formRadio: {
        flexDirection: "row",
        marginLeft: '100px'
    },
    formRadioSelection: {
        flexDirection: "row",
    },
    formButton: {
    },
    formSelection: {
    },
    smallerPadding: {
        padding: '5px 15px',
    }
});

export default withStyles(styles)(Presses)



// WEBPACK FOOTER //
// ./resources/assets/js/components/Protocols/Protocols/Presses.js